const { format } = require('date-fns');

const formatDate = (date) => (date ? format(new Date(date), 'dd-MMM-yy') : 'N/A');

export function fDate(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy';

  return date ? format(new Date(date), fm) : '';
}

export default formatDate;
